export default __webpack_public_path__ + "static/media/how-it-works-5.27f83563.png";